// Angular
import { CommonModule } from '@angular/common'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { ModuleWithProviders, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule, Routes } from '@angular/router'
import { EffectsModule } from '@ngrx/effects'
// NGRX
import { StoreModule } from '@ngrx/store'
import { TranslateModule } from '@ngx-translate/core'
// Auth
import { AuthEffects, AuthGuard, authReducer, AuthService } from '../../../core/auth'
// CRUD
import { InterceptService } from '../../../core/_base/crud/'
import { MaterialModule } from '../../../material.module'
import { PartialsModule } from '../../partials/partials.module'
import { AuthNoticeComponent } from './auth-notice/auth-notice.component'
// Module components
import { AuthComponent } from './auth.component'
import { LoginComponent } from './login/login.component'

const routes: Routes = [
	{
		path: '',
		component: AuthComponent,
		children: [
			{
				path: '',
				redirectTo: 'login',
				pathMatch: 'full'
			},
			{
				path: 'login',
				component: LoginComponent,
				data: { returnUrl: window.location.pathname }
			},
			{
				path: 'login/:token/:url',
				component: LoginComponent,
				data: { returnUrl: window.location.pathname }
			},
			{
				path: 'login/:token/:url/:cropped',
				component: LoginComponent,
				data: { returnUrl: window.location.pathname }
			}
		]
	}
]


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule.forChild(routes),
		TranslateModule.forChild(),
		StoreModule.forFeature('auth', authReducer),
		EffectsModule.forFeature([AuthEffects]),
		PartialsModule,
		MaterialModule
	],
	providers: [
		InterceptService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: InterceptService,
			multi: true
		},
	],
	exports: [AuthComponent],
	declarations: [
		AuthComponent,
		LoginComponent,
		AuthNoticeComponent
	]
})

export class AuthModule {
	static forRoot(): ModuleWithProviders {
		return {
			ngModule: AuthModule,
			providers: [
				AuthService,
				AuthGuard
			]
		}
	}
}
